import { Component, OnInit } from "@angular/core";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { ChequeIssuedService } from "src/app/services/sales-reports/cheque-issued";

@Component({
  selector: "app-cheque-issued",
  templateUrl: "./cheque-issued.component.html",
  styleUrls: ["./cheque-issued.component.css"],
})
export class ChequeIssuedComponent implements OnInit {
  faPrint = faPrint;
  lockPrint: boolean = true;

  FormFields: FormField[] = [
    {
      type: "date",
      id: "FromDate",
      label: "From Cheque Date (dd/mm/yyyy)",
    },
    {
      type: "date",
      id: "ToDate",
      label: "To Cheque Date (dd/mm/yyyy)",
    },
    {
      type: "select",
      id: "Format",
      label: "Select format",
      options: [
        { display: "PDF", value: "pdf" },
        { display: "EXCEL", value: "excel" },
        { display: "BOTH", value: "both" },
      ],
      value: "pdf",
    },
  ];

  constructor(
    private notifier: NotifierService,
    private chequeIssuedComponent: ChequeIssuedService,
  ) {}

  ngOnInit() {}

  update(): void {
    if (
      this.getField("FromDate").value &&
      this.getField("ToDate").value
    ) {
      this.lockPrint = false;
    } else {
      this.lockPrint = true;
    }
  }

  print(): void {
    const FromDate = this.getField("FromDate").value;
    const ToDate = this.getField("ToDate").value;
    const Format = this.getField("Format").value;

    if (!FromDate || !ToDate) {
      this.notifier.notify(
        "error",
        "Please provide valid date values",
      );
      return;
    }

    const formattedFromDate = formatDate(
      FromDate,
      "dd/MM/yyyy",
      "en-US",
    );
    const formattedToDate = formatDate(ToDate, "dd/MM/yyyy", "en-US");

    this.chequeIssuedComponent
      .ChequeIssuedReport(formattedFromDate, formattedToDate)
      .subscribe({
        next: ({ body }) => {
          if (["pdf", "both"].includes(Format)) {
            window.open(body.Name, "_blank");
          }
          if (["excel", "both"].includes(Format)) {
            window.open(body.Value, "_blank");
          }
        },
        error: console.error,
      });
  }

  getField(id: string): FormField {
    return (
      this.FormFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: null,
      }
    );
  }
}
